import router from '../router';
const state = {
    searchIsActive: false,
    invoiceSearchResult: [],
    invoiceSearchQuery: null,
};

const getters = {

};

const mutations = {
	setSearchActive(state) {
        state.searchIsActive = false;
    },
    clearInvoiceSearchResult(state) {
        state.invoiceSearchResult = []
    },
    clearInvoiceSearchQuery(state) {
        state.invoiceSearchQuery = []
    },
};

const actions = {
    setSearchActive({commit}) {
        commit('setSearchActive');
    },
    clearInvoiceSearchResult({commit}){
        commit('clearInvoiceSearchResult');
    },
    clearInvoiceSearchQuery({commit}) {
        commit('clearInvoiceSearchQuery');
    },
    
    
    
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};